import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';
import { Heading5 } from '../../../../ui-components/typography/Heading.styles';

export const StyledExternalTeaser = styled.li`
    margin: 0 auto;
    display: inline-block;
    vertical-align: top;
    width: calc(50% - 2.5px);

    @media ${device.GteMedium} {
        width: calc(25% - 3.75px);
    }

    @media ${device.GteLarge} {
        width: calc(25% - 8px);
    }

    @media ${device.GteLarge} {
        width: calc(25% - 10px);
    }
`;

export const Link = styled.a`
    text-decoration: none;
`;

export const Title = styled(Heading5)`
    margin-top: 15px;
    margin-bottom: 7px;
`;

export const TitleText = styled.span`
    &:hover {
        text-decoration: underline;
    }
`;
